`
<template>
	<div class="faq">
		<b-row>
			<b-col cols="12" md="6" class="d-flex" v-for="(item, index) in data.faq" :key="index">
				<div class="faq-container d-flex align-items-stretch align-self-stretch">
					<b-button class="faq-button d-flex justify-content-between align-items-center"
					          v-b-toggle="'collapse-'+index">
						<p class="text">{{item.text}}</p>
						<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
							<g clip-path="url(#clip0)">
								<path
									d="M17.0912 8.60591L15.3941 6.90885L12 10.303L8.60589 6.90885L6.90883 8.60591L10.3029 12L6.90883 15.3941L8.60589 17.0912L12 13.6971L15.3941 17.0912L17.0912 15.3941L13.6971 12L17.0912 8.60591Z"
									fill="white"/>
								<path
									d="M20.4853 3.51473C15.8065 -1.16405 8.1935 -1.16405 3.51472 3.51473C-1.16407 8.19351 -1.16407 15.8065 3.51472 20.4853C8.1935 25.1641 15.8065 25.1641 20.4853 20.4853C25.1641 15.8065 25.1641 8.19351 20.4853 3.51473ZM5.21177 18.7882C1.46892 15.0454 1.46892 8.95464 5.21178 5.21179C8.95463 1.46893 15.0454 1.46893 18.7882 5.21179C22.5311 8.95464 22.5311 15.0454 18.7882 18.7882C15.0454 22.5311 8.95463 22.5311 5.21177 18.7882Z"
									fill="white"/>
							</g>
							<defs>
								<clipPath id="clip0">
									<rect width="24" height="24" fill="white" transform="translate(12 -4.97055) rotate(45)"/>
								</clipPath>
							</defs>
						</svg>
					</b-button>
					<b-collapse :id="'collapse-'+index">
						<b-card>
							<div class="card-text">
								<wysiwyg-component v-html="item.wysiwyg">
								</wysiwyg-component>
							</div>
						</b-card>
					</b-collapse>
				</div>
			</b-col>
		</b-row>
	</div>
</template>

<script>
	const axios = require('axios');
	export default {
		data() {
			return {
				data: {}
			}
		},
		beforeCreate () {
			axios.get(`${this.$root.routLink}${this.$route.path}?ajax&act=faq`,
				{responseType: 'json'}
			).then(({data}) => {
				this.data = JSON.parse(data.addons);
				if (this.data.visible !== 1) {
					this.$emit('hideup')
				}
			})
		},
	}
</script>

<style lang="scss" scoped>
	
	.faq {
		.faq-container {
			width: 100%;
			margin-bottom: 5px;
			border-radius: 5px;
			position: relative;
			.faq-button {
				width: 100%;
				padding: 12px 25px;
				border-color: #FFFFFF;
				box-shadow: none;
				box-sizing: border-box;
				background: linear-gradient(97.55deg, #850000 6.18%, rgba(133, 0, 0, 0) 66.95%), #B33031;
				border-radius: 5px 5px 0px 0px;
				@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
					padding: 20px 10px;
					border: none;
				}
			
				.text {
					font-weight: 500;
					font-size: 18px;
					line-height: 130%;
					color: #FFFFFF;
					transition: all 0.3s ease-in-out;
					text-align: start;
					@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
						font-size: 14px;
					}
		
				}
				svg {
					transition: all 0.3s ease-in-out;
					flex-shrink: 0;
					@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
						margin-left: 18px;
					}
					path {
						transition: all 0.3s ease-in-out;
						fill: #FFFFFF;
					}
				}
				&.collapsed {
					padding: 12px 25px;
					background: #FFFFFF;
					border-color: #FFFFFF;
					box-shadow: none;
					box-sizing: border-box;
					border-radius: 5px 5px 0px 0px;
					transition: all 0.3s ease-in-out;
					@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
						padding: 20px 10px;
						margin-bottom: 10px;
						border-radius: 5px;
					}
					.text {
						font-weight: 500;
						font-size: 18px;
						line-height: 130%;
						color: #6B6B6B;
						transition: all 0.3s ease-in-out;
						@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
							font-size: 14px;
						}
					}
					svg {
						transition: all 0.3s ease-in-out;
						transform: rotate(45deg);
						flex-shrink: 0;
						path {
							transition: all 0.3s ease-in-out;
							fill: #6B6B6B;
						}
					}
					&:hover, &:active, &:focus {
						box-shadow: 0px 0px 34px rgba(179, 48, 49, 0.2);
						.text {
							color: $activeColor;
						}
						svg {
							path {
								fill: $activeColor;
							}
						}
					}
				}
			}
			&>div {
				position: absolute;
				top: 100%;
				z-index: 10;
			}
		}
	}

</style>`